import React, { Fragment } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import isInternetExplorer from "@js/helpers/is_internet_explorer.js";

import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

const RenderedHTMLImage = (props) => {
  switch (props.step) {
    case "ready":
      let styleOverride = {};
      if (isInternetExplorer()) {
        // Because we need to support 3 different rulesets for how z-index is handled
        styleOverride.zIndex = 0; // This is the only way to get images to show in chrome, safari, edge, and IE using the same CSS
      }
      return <img src={props.image_url} style={styleOverride} />;
    case "error":
      return (
        <div className="campaign-content-section-entry-add-button">
          <FontAwesomeIcon icon={faExclamation} />
          <p>{t("phrases.react_content.error_generating_preview")}</p>
        </div>
      );
    case "no_content_to_preview":
      return null;
    default:
      return (
        <div className="loading-spinner-container">
          <LoadingSpinner />
          <p
            style={{
              color: "black", // This is usually red because we're usually displaying errors here
            }}
          >
            {t(`phrases.react_content.loading_preview`)}
          </p>
        </div>
      );
  }
};

export default RenderedHTMLImage;
